module.exports = __webpack_public_path__ + "img/1542805745.151c1b39.jpg";